import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectContainersByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";
import {
    selectCurrentPage,
    updateCurrentPage,
} from "../../../redux/slices/currentPageSlice";
import ReceiptPage from "./ReceiptPage";

const ConnectedReceiptPage = () => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const containers = useSelector((state) =>
        selectContainersByPage(
            state,
            DefaultView.STANDARD_REGISTRATION_RECEIPT,
        ),
    );
    const title = useSelector((state) =>
        selectSpecificFormSetting(state, "title"),
    );

    const currentPage = useSelector(selectCurrentPage);

    const documentTitle = `${title} | Confirmation`;

    const receiptPageProps = {
        documentTitle,
        containers,
        currentPage,
        receiptDefaultView: DefaultView.STANDARD_REGISTRATION_RECEIPT,
        updateCurrentPage,
    };

    return <ReceiptPage {...receiptPageProps} />;
};

export default ConnectedReceiptPage;
